import React from 'react';
import { motion } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * Oblique Design System — NewOptionsPanel
 * ═══════════════════════════════════════════════════════════════════════════
 */

export function NewOptionsPanel({ onCreateNew, onImport, onHubspotFetch, onClose, customOptions, importLabel = 'Import from CSV' }) {
    const defaultOptions = [
        { label: 'Standard Record', icon: <ObliqueIcon name="description" size={16} />, type: 'default', rightText: 'Default' },
        { label: importLabel, icon: <ObliqueIcon name="upload_file" size={16} />, type: 'import', rightText: 'CSV' },
        { label: 'Import from HubSpot', icon: <ObliqueIcon name="sync" size={16} />, type: 'hubspot', rightText: '' },
        { label: 'Bulk Randomizer', icon: <ObliqueIcon name="shuffle" size={16} />, type: 'random', rightText: '' },
    ];
    const options = customOptions || defaultOptions;

    return (
        <motion.div
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 4 }}
            transition={{ duration: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="absolute top-[calc(100%+6px)] right-0 w-[260px] bg-[var(--bg-surface)] border border-[var(--border)] rounded-lg shadow-[0_6px_20px_rgba(0,0,0,0.12)] z-[2000] p-1"
        >
            <div className="pt-1 px-2 pb-2 text-[11px] font-medium text-[var(--text-tertiary)]">
                Templates
            </div>
            {options.map((opt, i) => (
                <div
                    key={i}
                    onClick={() => {
                        onClose();
                        if (opt.type === 'import' && onImport) onImport();
                        else if (opt.type === 'hubspot' && onHubspotFetch) onHubspotFetch();
                        else onCreateNew(opt.type);
                    }}
                    className="flex items-center gap-2 py-1.5 px-2 cursor-pointer rounded hover:bg-[var(--bg-muted)] transition-colors duration-150"
                >
                    <div className="flex text-[var(--text-tertiary)]">
                        {opt.icon}
                    </div>
                    <div className="text-[13px] text-[var(--text-primary)]">{opt.label}</div>
                    {opt.rightText && (
                        <div className="ml-auto text-[11px] font-medium text-[var(--text-tertiary)] bg-[var(--bg-subtle)] py-0.5 px-1.5 rounded">
                            {opt.rightText}
                        </div>
                    )}
                </div>
            ))}
        </motion.div>
    );
}
